module.exports = __webpack_public_path__ + "static/media/stocks-demo.67149b83.gif";